var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 19,
    viewBox: "0 0 28 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0b6462;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.628,7.183,4.666,13.623v6.951a.733.733,0,0,0,.778.679l5.447-.012a.733.733,0,0,0,.774-.679V16.5a.733.733,0,0,1,.778-.679h3.111a.733.733,0,0,1,.778.679V20.56a.638.638,0,0,0,.227.481.839.839,0,0,0,.551.2l5.445.013a.733.733,0,0,0,.778-.679V13.619l-8.96-6.436A.661.661,0,0,0,13.628,7.183ZM27.784,11.56,23.72,8.637V2.763a.55.55,0,0,0-.583-.509H20.415a.55.55,0,0,0-.583.509v3.08L15.48,2.718a2.6,2.6,0,0,0-2.965,0L.211,11.56a.466.466,0,0,0-.078.717l1.239,1.315a.612.612,0,0,0,.395.183.643.643,0,0,0,.427-.114L13.628,5.444a.661.661,0,0,1,.744,0l11.434,8.218a.643.643,0,0,0,.821-.068l1.239-1.315A.466.466,0,0,0,28,11.9a.494.494,0,0,0-.212-.344Z",
    transform: "translate(0.001 -2.254)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fb39cb611e49864f365c5e39754a1d6c.svg";
export { ForwardRef as ReactComponent };